<script>
import {useStore} from "vuex";
import {ref, watch} from "vue";
import router from "@/router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import {useRoute} from "vue-router";

export default {
  name: "NavbarPage",
  components: {LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()
    let count_orders = ref(store.state.order.products.length)
    let input_search = ref('')

    let show_location = ref(useRoute().name === 'HomePage')

    let loading = ref(false)

    let cities = ref([])
    let country = ref([])
    let dialog = ref(false)

    let page_alert = ref('state')
    let place = ref({
      state: null,
      city: null
    })

    let my_profile = ref(store.state.my_profile)

    async function alert_country(action, id) {

      if (action === 'state') {

        if (id === -1) {
          place.value.state = id
          place.value.city = id
          dialog.value = false
          set_user()
          return false
        }

        place.value.state = id
        country.value.forEach((item) => {
          if (id == item.id) {
            cities.value = item.city
          }
        })
        // $("#alert_state").addClass('animate__animated animate__fadeOut')
        page_alert.value = 'city'

      } else {
        place.value.city = id
        dialog.value = false
        set_user()
      }

    }

    function set_user() {

      loading.value = true

      let data = {
        action: 'search',
        search_state: place.value.state,
        search_city: place.value.city,
      }

      FreeWorld.Heisenberg(data, 'user_edit', true).then((result) => {

        loading.value = false
        let res = result.data
        if (res.event === "update ok") {

          my_profile.value.search_state = place.value.state
          my_profile.value.search_city = place.value.city
          store.commit('set_my_profile', my_profile.value)
          place.value = {
            state: null,
            city: null
          }

          window.location.reload()

        } else {

          Swal.fire({
            position: "center",
            icon: "error",
            title: "متاسفانه لوکیشن شما ویرایش نشد",
            showConfirmButton: true,
            confirmButtonText: 'متوجه شدم',
            allowOutsideClick: false,
            showClass: {
              popup: 'animate__animated animate__bounceInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__bounceOutUp'
            }
          })

        }

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, set_user)
      })

    }

    async function get_country() {

      if (country.value.length > 0) {
        dialog.value = true
        return false
      }

      loading.value = true

      await FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        country.value = res.data.results
        dialog.value = true

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, get_country)
      })
    }

    watch(() => store.state.order.products.length, (newLength) => {
      count_orders.value = newLength
    })

    function check_orders() {
      if (count_orders.value !== 0) {
        router.push({name: 'OrdersPage'})
      }
    }

    function search_products() {
      if (input_search.value.trim().length === 0) return false

      router.push({name: 'SearchBy', params: {word: input_search.value}})
    }

    return {
      count_orders,
      check_orders,
      search_products,
      input_search,
      country,
      cities,
      get_country,
      loading,
      dialog,
      page_alert,
      alert_country,
      my_profile,
      show_location,
    }
  }
}
</script>

<template>

  <div v-if="loading" class="bg_alert"></div>
  <LoadingPage v-if="loading"></LoadingPage>

  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        scrollable
        max-width="40rem"
        height="40rem">

      <v-card class="rounded-4">
        <v-card-title class="font-3 text-center mt-2">فیلتر محصولات نسبت به شهر و استان خود</v-card-title>
        <v-divider></v-divider>

        <v-card-text v-if="page_alert == 'state' " id="alert_state" style="height: 300px;">

          <v-btn-group class="w-100 mb-2 rounded-4">
            <v-btn :active="my_profile.search_state == -1" @click="alert_country('state' , -1)"
                   class="w-100 font-4 bg-main">همه استان ها
            </v-btn>
          </v-btn-group>

          <v-btn-group class="w-100 mb-2 rounded-4" v-for="item in country" :key="item.id">
            <v-btn :active="my_profile.search_state == item.id" @click="alert_country('state' , item.id)"
                   class="w-100 font-4 bg-main">{{ item.name }}
            </v-btn>
          </v-btn-group>

        </v-card-text>

        <v-card-text v-else id="alert_city" class="" style="height: 300px;">

          <v-btn-group class="w-100 mb-2 rounded-4">
            <v-btn :active="my_profile.search_city == -1" @click="alert_country('city' , -1)"
                   class="w-100 font-4 bg-main">همه شهر ها
            </v-btn>
          </v-btn-group>

          <v-btn-group class="w-100 mb-2 rounded-4" v-for="item in cities" :key="item.id">
            <v-btn :active="my_profile.search_city == item.id" @click="alert_country('city' , item.id)"
                   class="w-100 font-4 bg-main">{{ item.name }}
            </v-btn>
          </v-btn-group>

        </v-card-text>

        <v-divider></v-divider>


      </v-card>
    </v-dialog>
  </v-row>

  <div class="navbar_container bg-shades-white p-3 d-flex justify-space-between align-items-center">
    <div class="d-flex align-items-center w-55 justify-content-evenly">
      <router-link :to="{name:'HomePage'}">
        <img class="img_logo" src="../../assets/img/Untitled.png" alt="">
      </router-link>
      <router-link :to="{name:'ProductsCategory'}" class="font-5 item_hover">فروشگاه</router-link>
      <a href="/HomePage#Services" class="font-5 item_hover">خدمات ما</a>
      <router-link :to="{name:'SupportPage'}" class="text-decoration-none font-5 item_hover">تماس با ما</router-link>
      <router-link :to="{name: 'RulesPage' , params:{action:'about_us'}}"
                   class="text-decoration-none font-5 item_hover">درباره ما
      </router-link>
    </div>

    <div class="d-flex justify-content-around align-items-center w-40">
      <div class="position-relative shadow-costom rounded-pill w-40 p-2">
        <input v-model="input_search" @keydown.enter="search_products" type="search" class="border-0 w-100 text-center">

        <svg @click="search_products" style="left:10px;" xmlns="http://www.w3.org/2000/svg" width="25" height="25"
             fill="currentColor"
             class="bi bi-search position-absolute" viewBox="0 0 16 16">
          <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
        </svg>
      </div>

      <router-link :to="{name:'ProfilePage'}" class="item_hover">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-person "
             viewBox="0 0 16 16">
          <path
              d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
        </svg>
      </router-link>

      <div @click="check_orders" class="position-relative item_hover">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor"
             class="bi bi-bag-check" viewBox="0 0 16 16">
          <path fill-rule="evenodd"
                d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
          <path
              d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
        </svg>

        <p style="left: -10px;top:-10px;" class="bg-danger text-white font-5 position-absolute rounded-pill py-1 px-2">
          {{ count_orders }}</p>
      </div>

      <img v-if="show_location" style="width: 3rem" @click="get_country" class="" src="../../assets/img/location_home_icon.svg" alt=""
           loading="lazy">
    </div>
  </div>
  <br>
  <br>
  <br>
  <br>
  <br>
</template>

<style scoped>
.bg_alert {
  pointer-events: none;
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(79, 78, 78, 0.7);
  z-index: 50;
}

p {
  margin: 0;
}

.navbar_container {
  width: 101%;
  height: 5.7rem;
  position: fixed;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid rgba(136, 136, 136, 0.56);
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
}

.img_logo {
  width: 50px;
}

.item_hover {
  transition: .5s;
  border-radius: 30px;
  padding: 1.5%;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color: black;
}

.item_hover:hover {
  background-color: #818285;
  color: white;
  outline: 1px solid #818285;
}

</style>